import { range } from '@pacote/array';
import { defaultHash } from './hash';
export class BloomFilter {
    constructor(options) {
        var _a, _b, _c;
        if (options.size < 1) {
            throw Error('size must be greater than 0');
        }
        if (options.hashes < 1) {
            throw Error('number of hashes must be greater than 0');
        }
        this.size = options.size;
        this.hashes = options.hashes;
        this.seed = (_a = options.seed) !== null && _a !== void 0 ? _a : 0x00c0ffee;
        this.filter = (_b = options.filter) !== null && _b !== void 0 ? _b : new Uint32Array(Math.ceil(this.size / 32));
        this.hash = (_c = options.hash) !== null && _c !== void 0 ? _c : defaultHash(this.seed);
    }
    add(element) {
        range(0, this.hashes).forEach((i) => {
            const hashedValue = this.hash(i, element.toString()) % this.size;
            const position = Math.floor(hashedValue / 32);
            this.filter[position] |= 1 << (hashedValue - position * 32);
        });
    }
    has(element) {
        return range(0, this.hashes).every((i) => {
            const hashedValue = this.hash(i, element.toString()) % this.size;
            const position = Math.floor(hashedValue / 32);
            return this.filter[position] & (1 << (hashedValue - position * 32));
        });
    }
    toJSON() {
        return {
            filter: Array.from(this.filter),
            hashes: this.hashes,
            seed: this.seed,
            size: this.size,
        };
    }
}
//# sourceMappingURL=bloom-filter.js.map